module.exports = __webpack_public_path__ + "static/media/mainimg-04.92b6c7c4.png";